import { AppForm } from "@/shared/Components";
import type { UseFormReturn } from "react-hook-form";
import type { FC, PropsWithChildren } from "react";
import type { Person } from "@/services/api";
import type { DeleteConnectionFormValues } from "../../model/schema";

type Props = {
  formApi: UseFormReturn<DeleteConnectionFormValues>;
  onSubmit: (deletedConnections: Person["personConnections"]) => void;
  defaultValues: Person["personConnections"];
};

export const Form: FC<PropsWithChildren<Props>> = ({ children, onSubmit, formApi }) => {
  const submitHandler = (data: DeleteConnectionFormValues) => {
    onSubmit(
      data?.connections
        ?.filter((item) => item.selected)
        .map((item) => item.connection) as Person["personConnections"],
    );
    formApi.reset();
  };
  return (
    <AppForm formApi={formApi} onSubmit={submitHandler}>
      {children}
    </AppForm>
  );
};
